import * as Sentry from "@sentry/react";
export const initSentry = () => {
  const isProd = import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.VITE_APP_ENV === 'staging';
  if (isProd) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      enabled: isProd,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.captureConsoleIntegration(),
        Sentry.httpContextIntegration()
      ],
      tracesSampleRate: 1.0,
      profilesSampleRate: 1.0,
      enableLogs: true,
      release: import.meta.env.VITE_REACT_APP_RELEASE_VERSION,
      environment: import.meta.env.VITE_APP_ENV
    });
  }
};